import {MAX_LOGS_COUNT} from "../../util/Constants";
import {LogStoreAction} from "../action/LogStoreAction";

export const LogStoreReducer = (state, action) => {
  switch (action.type) {

    case LogStoreAction.FILTER_LOGS: {
      const filteredItems = state.rawLogs.filter((log) => shouldDisplayLog(log, state));
      return { ...state, filteredLogs: filteredItems };
    }

    case LogStoreAction.CLEAR_LOGS: {
      return { ...state, rawLogs: [], filteredLogs: [] };
    }

    case LogStoreAction.CLEAR_FILTERING: {
      return { ...state, filterQuery: '', deviceNameQuery: '',  maxMessageCount: MAX_LOGS_COUNT };
    }

    case LogStoreAction.SET_MAX_MSG_COUNT: {
      if (action.data.maxMessageCount.length === 0) {
        return { ...state, maxMessageCount: MAX_LOGS_COUNT, rawLogs: state.rawLogs.slice(0, MAX_LOGS_COUNT), filteredLogs: state.filteredLogs.slice(0, MAX_LOGS_COUNT) };
      } else {
        let count = parseInt(action.data.maxMessageCount, 10)
        if (count > MAX_LOGS_COUNT) {
          count = MAX_LOGS_COUNT
        }
        return { ...state, maxMessageCount:  count, rawLogs: state.rawLogs.slice(0, MAX_LOGS_COUNT), filteredLogs: state.rawLogs.slice(0, count) };
      }
    }

    case LogStoreAction.ADD_LOG: {
      if (shouldDisplayLog(action.data.event, state)) {
        state.filteredLogs.unshift(action.data.event)
      }
      state.rawLogs.unshift(action.data.event)
      return { ...state };
    }

    case LogStoreAction.ROLLUP_LOG: {
      if (state.rawLogs.length > state.maxMessageCount) {
        state.rawLogs.pop();
      }
      if (state.filteredLogs.length > state.maxMessageCount) {
        state.filteredLogs.pop();
      }
      return { ...state };
    }

    default:
      return state;
  }
};

const shouldDisplayLog = (log, state) => {
  return log.name.toLowerCase().includes(state.deviceNameQuery.toLowerCase()) &&
      Object.values(log).some(value => JSON.stringify(value).toLowerCase().includes(state.filterQuery.toLowerCase()))
}

export const initialState = {
  rawLogs: [],
  filteredLogs: [],
  maxMessageCount: MAX_LOGS_COUNT,
  filterQuery: '',
  deviceNameQuery: '',
};



// WEBPACK FOOTER //
// ./src/components/store/reducers/LogStoreReducer.js